export class BusinessInfo {
    userInfoId: string | undefined;
    gender: number | undefined; 
    firstName: string | undefined;
    lastName: string | undefined; 
    detailAddress: any | undefined; 
    phoneNumber: number | undefined; 
    businessWebsite: any | undefined; 
    businessName: string | undefined;
    businessKeywords: any | undefined; 
    categoryInfoId: number | undefined; 
    subCategoryInfoId: number | undefined;
    countryInfoId:any | undefined; 
    stateInfoId:any | undefined; 
    districtInfoId:any | undefined; 
    businessCity:string | undefined; 
    aboutBusiness:string | undefined; 
    businessDetails:string | undefined; 
    googleLongitude:any | undefined; 
    googleLatitude:any | undefined; 
    categoryName:any | undefined;
}
